export default __webpack_public_path__ + "static/media/contact-1.404c2ecc.png";